import { CircularProgress } from "@mui/material";
import React from "react";

const LoadingIcon = () => {
  return <CircularProgress color="warning" />;
};

export default LoadingIcon;
